import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {SteelProfileService} from '../steel-profile.service';
import {ProfileTypeService} from '../profile-type.service';
import {SteelProfile} from '../steel-profile';
import {NavService} from '../../_shared/nav/nav.service';
import {SidebarNode, SidebarOptions} from '../../_shared/nav/nav.interfaces';

@Component({
    selector: 'app-steel-profile-details',
    templateUrl: './steel-profile-details.component.html',
    styleUrls: ['./steel-profile-details.component.css'],
})
export class SteelProfileDetailsComponent implements OnInit {
    profileId: number;
    profile: SteelProfile;
    editedProfile: SteelProfile;
    waiting = false;
    formValidities = {
        'common': true,
        'specific': true
    };
    profiles: SteelProfile[];
    private navOptions: SidebarOptions = undefined;
    profileTypes = [];
    createProfileType: boolean = false;
    editProfileType: boolean = false;


    constructor(private route: ActivatedRoute,
                private profileService: SteelProfileService,
                private profileTypeService: ProfileTypeService,
                private router: Router,
                private nav: NavService) {

      this.navOptions = {
          title: 'PERFILES',
          entries: [],
          nodeClass: ''
      };
    }

    ngOnInit() {
        this.route.params
            .subscribe((params: Params) => {
                if(params['id']){
                  this.profileId = +params['id'];
                  this.profileService.get(this.profileId).subscribe((profile) => {
                      this.profile = profile;
                      this.editedProfile = Object.assign({}, this.profile);
                  });
                }

            });
        this.updateListProfiles();
        this.updateListProfileTypes();

        this.nav.updateSidebarOptions(this.navOptions);
    }

    cancelEdit() {
        this.editedProfile = Object.assign({}, this.profile);
        this.profileId = null;
    }

    save() {
        this.waiting = true;
        this.profileService.update(this.editedProfile).subscribe((editedProfile) => {
            this.profile = editedProfile;
            this.waiting = false;
            this.editedProfile = Object.assign({}, this.profile);
            this.updateListProfiles();
        });
        this.profileId = null;
    }

    updateListProfiles(){
      this.profileService.getAll().subscribe((profiles) => {
          this.profiles = profiles;
      });
    }

    updateListProfileTypes(){
      this.profileTypeService.getAll().subscribe(res => {
        this.profileTypes = [];
        for(var i = 0; i < res.length; i++){
          this.profileTypes[i] = {'name': res[i].name, 'value': res[i].id, 'family': res[i].family };
        }
      });
    }

    goToList() {
        this.router.navigate(['/perfiles']);
    }

    onCommonIsValid(valid: boolean) {
        this.formValidities.common = valid;
    }

    onSpecificIsValid(valid: boolean) {
        this.formValidities.specific = valid;
    }

    canEdit(): boolean {
        return this.formValidities.common && this.formValidities.specific;
    }

    clickProfile(profile){
      // this.profile = profile;
      // this.editedProfile = Object.assign({}, this.profile);
      this.profileId = profile.id;
      this.profileService.get(this.profileId).subscribe((profile) => {
          this.profile = profile;
          this.editedProfile = Object.assign({}, this.profile);
      });

    }

    delete(){
      this.waiting = true;
      this.profileService.delete(this.editedProfile.id).subscribe((editedProfile) => {
          this.profile = editedProfile;
          this.waiting = false;
          this.editedProfile = Object.assign({}, this.profile);
          this.updateListProfiles();
      });
      this.profileId = null;
    }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-details/steel-profile-details.component.ts